import type { BranchCategory } from '@festina/configuration-general-types/configuration'
import type { Optional } from '@festina-life/core'

export const ProtectedBranchCategories = [
  'main',
  'release',
] satisfies BranchCategory[]

export type ProtectedBranchCategory = (typeof ProtectedBranchCategories)[number]

export const isProtectedBranchCategory = (
  category: Optional<BranchCategory>,
): category is ProtectedBranchCategory =>
  !!category && (ProtectedBranchCategories as string[]).includes(category)
